export default "__VITE_ASSET__TSd7Ut5L__"